export class MensajesRespuestas {
  public static REGISTRO_YA_EXISTE = '1004';
  public static NO_HAY_DATOS = '1001';
}
